// src/plugin/browser.ts
var definitions = () => {
  throw new Error("Config plugin definitions are not available in the browser");
};
export {
  definitions
};
//# sourceMappingURL=browser.mjs.map
